import { AmericanFootballAttributeId } from './american-football/attributes/AmericanFootballAttributeId.js'
import { BaseballAttributeId } from './baseball/attributes/BaseballAttributeId.js'
import { BasketballAttributeId } from './basketball/attributes/BasketballAttributeId.js'
import { Basketball3x3AttributeId } from './basketball3x3/Basketball3x3Attribute.js'
import { BeachVolleyballAttributeId } from './beach-volleyball/attributes/BeachVolleyballAttribute.js'
import {
  BetStartAttribute,
  BetStopAttribute,
  BookingMarketsDisabledAttribute,
  BookingMarketsEnabledAttribute,
  CornerMarketsDisabledAttribute,
  CornerMarketsEnabledAttribute,
} from './common/index.js'
import { CricketAttributeId } from './cricket/attributes/CricketAttributeIds.js'
import { HandballAttributeId } from './handball/attributes/HandballAttributeId.js'
import { IceHockeyAttributeIds } from './ice-hockey/attributes/IceHockeyAttributeIds.js'
import { RugbyLeagueAttributeId } from './rugby-league/index.js'
import { RugbyUnionAttributeId } from './rugby-union/index.js'
import { SoccerAttributeId } from './soccer/attributes/SoccerAttributeIds.js'
import { VolleyballAttributeId } from './volleyball/attributes/VolleyballAttribute.js'

export enum CommonAttributeId {
  None = 0,
}

export type IncidentAttributeId =
  | SoccerAttributeId
  | HandballAttributeId
  | VolleyballAttributeId
  | CricketAttributeId
  | BasketballAttributeId
  | BaseballAttributeId
  | BeachVolleyballAttributeId
  | Basketball3x3AttributeId
  | AmericanFootballAttributeId
  | CommonAttributeId
  | IceHockeyAttributeIds
  | BetStartAttribute
  | BetStopAttribute
  | CornerMarketsEnabledAttribute
  | CornerMarketsDisabledAttribute
  | BookingMarketsEnabledAttribute
  | BookingMarketsDisabledAttribute
  | RugbyUnionAttributeId
  | RugbyLeagueAttributeId
